import { Link } from "react-router-dom";
import Seo from "../lib/seo";
import { Overline } from "../components/site/Reveal";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | NanoMax Holo Solutions" description="The page you are looking for could not be found." path="/404" />
      <section className="px-6 md:px-10 lg:px-16 min-h-[70vh] flex flex-col justify-center">
        <Overline>Error 404</Overline>
        <h1 className="font-head font-black uppercase tracking-tighter text-5xl md:text-7xl mt-5">Page <span className="holo-text">not found</span></h1>
        <p className="text-[#8A8A9B] mt-6 max-w-md">The page you are looking for may have moved or no longer exists. Explore our products or get in touch.</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/" className="btn-primary px-8 py-4 text-sm" data-testid="notfound-home">Back to Home</Link>
          <Link to="/products" className="btn-ghost px-8 py-4 text-sm">View Products</Link>
        </div>
      </section>
    </>
  );
}
